import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { BASE_ROUTE } from './config';
import Login from './routes/login';
import PurchaseList from './routes/purchase/list';
import PurchaseDetail from './routes/purchase/detail';
import PurchaseRefundList from './routes/purchase/refund/list';
import PurchaseRefundDetail from './routes/purchase/refund/detail';
import PurchaseShipEntry from './routes/purchase/ship';
import PurchaseShipList from './routes/purchase/ship/list';
import PurchaseShipDetail from './routes/purchase/ship/detail';
import PurchaseRejectList from './routes/purchase/reject/list';
import PurchaseVendorMaterialShortages from './routes/purchase/vendor_material_shortages';
import OutsourcingList from './routes/outsourcing/list';
import OutsourcingDetail from './routes/outsourcing/detail';
import OutsourcingRefundList from './routes/outsourcing/refund/list';
import OutsourcingRefundDetail from './routes/outsourcing/refund/detail';
import OutsourcingShipEntry from './routes/outsourcing/ship';
import InvoiceList from './routes/invoice/list';
import InvoiceDetail from './routes/invoice/detail';
import Logout from './routes/logout';
import OutsourcingShipDetail from './routes/outsourcing/ship/detail';
import Account from './routes/account';
import CompanyUser from './routes/company';
import PurchaseRejectDetail from './routes/purchase/reject/detail';
import OutsourcingRejectDetail from './routes/outsourcing/reject/detail';
import OutsourcingShipList from './routes/outsourcing/ship/list';
import OutsourcingRejectList from './routes/outsourcing/reject/list';
import OutsourcingVendorMaterialShortages from './routes/outsourcing/vendor_material_shortages';

const router = createBrowserRouter([{
  path: `${BASE_ROUTE}`,
  element: <App />,
  children: [{
    path: `${BASE_ROUTE}/login`,
    element: <Login />
  },{
    path: `${BASE_ROUTE}/logout`,
    element: <Logout />
  },{
    path: `${BASE_ROUTE}/account`,
    element: <Account />
  },{
    path: `${BASE_ROUTE}/purchase/list`,
    element: <PurchaseList />
  },{
    path: `${BASE_ROUTE}/purchase/detail/:ch_no`,
    element: <PurchaseDetail />
  },{
    path: `${BASE_ROUTE}/purchase/refund/list`,
    element: <PurchaseRefundList />
  },{
    path: `${BASE_ROUTE}/purchase/refund/detail/:mt_list`,
    element: <PurchaseRefundDetail />
  },{
    path: `${BASE_ROUTE}/purchase/ship/entry`,
    element: <PurchaseShipEntry />
  },{
    path: `${BASE_ROUTE}/purchase/ship/list`,
    element: <PurchaseShipList />
  },{
    path: `${BASE_ROUTE}/purchase/ship/detail/:fd_no`,
    element: <PurchaseShipDetail />
  },{
    path: `${BASE_ROUTE}/purchase/reject/detail/:dl_no`,
    element: <PurchaseRejectDetail />
  },{
    path: `${BASE_ROUTE}/purchase/reject/list`,
    element: <PurchaseRejectList />
  },{
    path: `${BASE_ROUTE}/purchase/vendor_material_shortages`,
    element: <PurchaseVendorMaterialShortages />
  },{
    path: `${BASE_ROUTE}/outsourcing/list`,
    element: <OutsourcingList />
  },{
    path: `${BASE_ROUTE}/outsourcing/detail/:os_odno`,
    element: <OutsourcingDetail />
  },{
    path: `${BASE_ROUTE}/outsourcing/refund/list`,
    element: <OutsourcingRefundList />
  },{
    path: `${BASE_ROUTE}/outsourcing/refund/detail/:mt_list`,
    element: <OutsourcingRefundDetail />
  },{
    path: `${BASE_ROUTE}/outsourcing/ship/entry`,
    element: <OutsourcingShipEntry />
  },{
    path: `${BASE_ROUTE}/outsourcing/ship/list`,
    element: <OutsourcingShipList />
  },{
    path: `${BASE_ROUTE}/outsourcing/ship/detail/:fd_no`,
    element: <OutsourcingShipDetail />
  },{
    path: `${BASE_ROUTE}/outsourcing/reject/detail/:dl_no`,
    element: <OutsourcingRejectDetail />
  },{
    path: `${BASE_ROUTE}/outsourcing/reject/list`,
    element: <OutsourcingRejectList />
  },{
    path: `${BASE_ROUTE}/outsourcing/vendor_material_shortages`,
    element: <OutsourcingVendorMaterialShortages />
  },{
    path: `${BASE_ROUTE}/invoice/list`,
    element: <InvoiceList />
  },{
    path: `${BASE_ROUTE}/invoice/detail/:pay_no`,
    element: <InvoiceDetail />
  },{
    path: `${BASE_ROUTE}/provider`,
    element: <CompanyUser />
  },{
    path: `${BASE_ROUTE}`,
    element: <Account />
  }]
}]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);

